import styled from "styled-components";

export const NavLinksWrapper = styled.nav<React.HTMLAttributes<HTMLElement>>`
  max-width: 30rem;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: 3rem;
`;

interface NavLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
}

export const NavLink = styled.a<NavLinkProps>``;

export const LinksDescription = styled.p<React.HTMLAttributes<HTMLParagraphElement>>`
  margin: 0;
`;
